export default __webpack_public_path__ + "static/app_store-6ab26bf3f4a2ff62c41d27f39e30062f.png";